import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Input,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardPackingUx = (props: any) => {
    return(
      <div
        id="CardPacking"
        style={{margin: "10px", backgroundColor: "rgba(198, 235, 243, 0.2)", height:"90%"}}>
        <div
          id="CardPackingUx-div-1"
          style={{display: "flex", alignItems: "center", margin: "10px 10px"}}>
          
          <label
            className="header"
            id="CardPackingUx-label-6"
            style={{fontWeight: "bold", fontSize: "18px", marginLeft: "4px"}}>
            {props.languageUX === "en" ? "Packing" : "Packing"}
          </label>
        </div>
        <div
          id="CardPackingUx-div-3">
          
          <hr
            id="CardPackingUx-hr-4">
          </hr>
        </div>
        <div
          id="CardPackingUx-div-7"
          style={{height:"90%",margin: "14px 14px",backgroundColor: "#FFFFFF"}}>
          
          <div
            id="CardPackingUx-div-9"
            style={{display: "flex", alignItems: "center", margin: "10px 0px"}}>
            
            <label
              id="CardPackingUx-label-8"
              style={{fontWeight: "bold", fontSize: "16px", marginLeft: "14px"}}>
              
            </label>
            <div
              id="CardPackingUx-div-11"
              style={{display:"flex", width:"auto", marginLeft: "auto"}}>
              
              <Button
                color="yellow"
                id="CardPackingUx-Button-10"
                onClick={props.addItem}
                size="small">
                {props.languageUX === "en" ? "Add" : "เพิ่ม"}
              </Button>
            </div>
          </div>
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.items}
            headers="No,Site,Item,Pieces,Remark,-"
            id="CardPackingUx-Table-12"
            keys="no,site_name,item_name,quantity,remark,delete"
            showPagination={false}
            style={{height: "35vh"}}
            widths="50,150,auto,150,350,100">
          </Table>
          <div
            id="CardPackingUx-div-58"
            style={{border:"1px solid #ccc", borderRadius: "4px", padding: "0px 8px 4px 10px", margin:"20px 0px"}}>
            
            <div
              id="CardPackingUx-div-67"
              style={{display: "flex", alignItems: "center", margin: "10px 0px"}}>
              
              <label
                id="CardPackingUx-label-68"
                style={{width:"180px",fontWeight: "bold", fontSize: "14px", margin: "0px 10px"}}>
                {props.languageUX === "en" ? "Nursing Diagnosis" : "การวินิจฉัยทางการพยาบาล"}
              </label>
              <Input
                id="CardPackingUx-Input-69"
                name="packingFormData.nursing_diagnosis"
                onChange={props.handleChangeData}
                style={{width:"300px"}}
                value={props.ORCountsSequence?.packingFormData?.nursing_diagnosis || ""}>
              </Input>
              <label
                id="CardPackingUx-label-70"
                style={{width:"120px",fontWeight: "bold", fontSize: "14px", marginLeft: "14px"}}>
                {props.languageUX === "en" ? "Goal" : "เป้าหมาย"}
              </label>
              <Input
                id="CardPackingUx-Input-71"
                name="packingFormData.goal"
                onChange={props.handleChangeData}
                style={{width:"300px"}}
                value={props.ORCountsSequence?.packingFormData?.goal || ""}>
              </Input>
            </div>
            <div
              id="CardPackingUx-div-76"
              style={{display: "flex", alignItems: "center", margin: "10px 0px"}}>
              
              <label
                id="CardPackingUx-label-77"
                style={{width:"180px",fontWeight: "bold", fontSize: "14px", margin: "0px 10px"}}>
                {props.languageUX === "en" ? "Plan and implementation" : "การวางแผนและการดำเนินการ"}
              </label>
              <Dropdown
                id="CardPackingUx-Dropdown-81"
                name="packingFormData.plan_and_implementation"
                onChange={props.handleChangeData}
                options={props.orPlanNImplPackingOpt || []}
                selection={true}
                style={{width:"300px"}}
                value={props.ORCountsSequence?.packingFormData?.plan_and_implementation || ""}>
              </Dropdown>
              <label
                id="CardPackingUx-label-79"
                style={{width:"120px",fontWeight: "bold", fontSize: "14px", marginLeft: "14px"}}>
                {props.languageUX === "en" ? "Evaluation" : "การประเมิน"}
              </label>
              <Input
                id="CardPackingUx-Input-80"
                name="packingFormData.evaluation"
                onChange={props.handleChangeData}
                style={{width:"300px"}}
                value={props.ORCountsSequence?.packingFormData?.evaluation || ""}>
              </Input>
            </div>
            <div
              id="CardPackingUx-div-72"
              style={{display: "flex", alignItems: "center", margin: "10px 0px"}}>
              
              <div
                id="CardPackingUx-div-73"
                style={{display:"flex", width:"auto", marginLeft: "auto"}}>
                
                <div
                  id="CardPackingUx-div-83">
                  {props.save}
                </div>
              </div>
            </div>
          </div>
          <div
            id="CardPackingUx-div-82"
            style={{width: "100%"}}>
            {props.ErrorMessage}
          </div>
        </div>
      </div>
    )
}


export default CardPackingUx

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPacking"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"10px\", backgroundColor: \"rgba(198, 235, 243, 0.2)\", height:\"90%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"10px 10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-div-3"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackingUx-hr-4"
        }
      },
      "seq": 4,
      "void": true
    },
    {
      "from": null,
      "id": 6,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Packing",
          "valueEN": "Packing"
        },
        "className": {
          "type": "value",
          "value": "header"
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-label-6"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"18px\", marginLeft: \"4px\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-div-7"
        },
        "style": {
          "type": "code",
          "value": "{height:\"90%\",margin: \"14px 14px\",backgroundColor: \"#FFFFFF\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-label-8"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"16px\", marginLeft: \"14px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-div-9"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"10px 0px\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Button",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม",
          "valueEN": "Add"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-Button-10"
        },
        "onClick": {
          "type": "code",
          "value": "props.addItem"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-div-11"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", width:\"auto\", marginLeft: \"auto\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 12,
      "name": "Table",
      "parent": 7,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.items"
        },
        "headers": {
          "type": "value",
          "value": "No,Site,Item,Pieces,Remark,-"
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-Table-12"
        },
        "keys": {
          "type": "value",
          "value": "no,site_name,item_name,quantity,remark,delete"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"35vh\"}"
        },
        "widths": {
          "type": "value",
          "value": "50,150,auto,150,350,100"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-div-58"
        },
        "style": {
          "type": "code",
          "value": "{border:\"1px solid #ccc\", borderRadius: \"4px\", padding: \"0px 8px 4px 10px\", margin:\"20px 0px\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-div-67"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"10px 0px\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "label",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยทางการพยาบาล",
          "valueEN": "Nursing Diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-label-68"
        },
        "style": {
          "type": "code",
          "value": "{width:\"180px\",fontWeight: \"bold\", fontSize: \"14px\", margin: \"0px 10px\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Input",
      "parent": 67,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackingUx-Input-69"
        },
        "name": {
          "type": "value",
          "value": "packingFormData.nursing_diagnosis"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width:\"300px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCountsSequence?.packingFormData?.nursing_diagnosis || \"\""
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "label",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "เป้าหมาย",
          "valueEN": "Goal"
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-label-70"
        },
        "style": {
          "type": "code",
          "value": "{width:\"120px\",fontWeight: \"bold\", fontSize: \"14px\", marginLeft: \"14px\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "Input",
      "parent": 67,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackingUx-Input-71"
        },
        "name": {
          "type": "value",
          "value": "packingFormData.goal"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width:\"300px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCountsSequence?.packingFormData?.goal || \"\""
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-div-72"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"10px 0px\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-div-73"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", width:\"auto\", marginLeft: \"auto\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "Button",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "Save"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-Button-75"
        },
        "onClick": {
          "type": "code",
          "value": "props.save"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-div-76"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"10px 0px\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "label",
      "parent": 76,
      "props": {
        "children": {
          "type": "value",
          "value": "การวางแผนและการดำเนินการ",
          "valueEN": "Plan and implementation"
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-label-77"
        },
        "style": {
          "type": "code",
          "value": "{width:\"180px\",fontWeight: \"bold\", fontSize: \"14px\", margin: \"0px 10px\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "label",
      "parent": 76,
      "props": {
        "children": {
          "type": "value",
          "value": "การประเมิน",
          "valueEN": "Evaluation"
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-label-79"
        },
        "style": {
          "type": "code",
          "value": "{width:\"120px\",fontWeight: \"bold\", fontSize: \"14px\", marginLeft: \"14px\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "Input",
      "parent": 76,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackingUx-Input-80"
        },
        "name": {
          "type": "value",
          "value": "packingFormData.evaluation"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width:\"300px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCountsSequence?.packingFormData?.evaluation || \"\""
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "Dropdown",
      "parent": 76,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPackingUx-Dropdown-81"
        },
        "name": {
          "type": "value",
          "value": "packingFormData.plan_and_implementation"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.orPlanNImplPackingOpt || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width:\"300px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCountsSequence?.packingFormData?.plan_and_implementation || \"\""
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ErrorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-div-82"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "code",
          "value": "props.save"
        },
        "id": {
          "type": "value",
          "value": "CardPackingUx-div-83"
        }
      },
      "seq": 83,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardPackingUx",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
